import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

import { ApiService } from '@app/core/http/api.service';

import { Observable } from 'rxjs';

import {
    IOcbAckWaiting,
} from '@app/core/models';

@Injectable()
export class AckWaitingService extends ApiService {

    private ackWaitingUrl: string;
    private options = {
        headers: this.defaultHeaders,
        observe: 'body' as 'body',
    };

    constructor(httpClient: HttpClient) {
        super(httpClient);
        this.ackWaitingUrl = `${environment.api.endpoint}/ACKWaiting`;
    }

    /**
     * Get the list of ACK waiting
     * @param environmentId Internal identifier of the environment
     * @param fileTransferId Internal identifier of the file transfer
     * @param includeDisabled {true} to get ACK waiting for which the alert has been disabled
     */
    public getAckWaiting(environmentId?: string, fileTransferId?: string, includeDisabled?: boolean): Observable<IOcbAckWaiting[]> {

        let url = `${this.ackWaitingUrl}?`;

        if (environmentId) { url = `${url}EnvironmentId=${environmentId}&`; }
        if (fileTransferId) { url = `${url}FileTransferId=${fileTransferId}&`; }
        if (includeDisabled) { url = `${url}IncludeDisabled=${includeDisabled}`; }

        return this.httpClient.get<IOcbAckWaiting[]>(url, this.options);
    }

    /**
     * Get an ACK waiting
     * @param ackWaitingId Internal identifier of the ACK waiting
     */
    public getAckWaitingById(ackWaitingId: string): Observable<IOcbAckWaiting> {
        const url = `${this.ackWaitingUrl}/${ackWaitingId}`;
        return this.httpClient.get<IOcbAckWaiting>(url, this.options);
    }

    /**
     * Disable the alert on a not received ACK
     * @param ackWaitingId Internal identifier of the a ACK waiting
     */
    public disableAlert(ackWaitingId: string): Observable<void> {
        const url = `${this.ackWaitingUrl}/${ackWaitingId}/DisableAlert`;
        return this.httpClient.post<void>(url, this.options);
    }
}
